var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "value": _vm.value,
      "disabled": _vm.disabled,
      "config": _vm.editorConfig
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('input', $event);
      }
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }